(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ramped-collection-directory"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ramped-az-directory')) {
  customElements.define('ramped-az-directory', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const source = this.querySelector('[data-directory-list]');
      if (!source) return;
      this.dataset.ready = 'true';
      const container = this.querySelector('[data-directory-groups]');
      const letters = this.querySelector('.ramped-directory__letters');
      const items = Array.from(source.children).sort((a, b) => a.textContent.trim().localeCompare(b.textContent.trim(), 'en-AU', { sensitivity: 'base', numeric: true }));
      const groups = new Map();
      items.forEach(item => {
        const initial = item.textContent.trim().charAt(0).toUpperCase();
        const letter = /^[A-Z]$/.test(initial) ? initial : '0–9';
        if (!groups.has(letter)) {
          const group = document.createElement('section');
          group.className = 'ramped-directory__group';
          group.id = 'Category-' + this.dataset.sectionId + '-' + (letter === '0–9' ? 'numbers' : letter);
          const title = document.createElement('h3');
          title.textContent = letter;
          const list = document.createElement('ul');
          list.setAttribute('role', 'list');
          group.append(title, list);
          container.append(group);
          const jump = document.createElement('a');
          jump.href = '#' + group.id;
          jump.textContent = letter;
          letters.append(jump);
          groups.set(letter, { group, list, jump });
        }
        groups.get(letter).list.append(item);
      });
      source.hidden = true;
      letters.hidden = false;
      this.querySelector('.ramped-directory__filter').hidden = false;
      this.querySelector('[data-directory-search]').addEventListener('input', event => {
        const query = event.target.value.trim().toLocaleLowerCase('en-AU');
        let visible = 0;
        groups.forEach(({ group, list, jump }) => {
          let matches = 0;
          Array.from(list.children).forEach(item => {
            item.hidden = !item.textContent.toLocaleLowerCase('en-AU').includes(query);
            if (!item.hidden) matches++;
          });
          group.hidden = matches === 0;
          jump.hidden = matches === 0;
          visible += matches;
        });
        this.querySelector('.ramped-directory__empty').hidden = visible > 0;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
